import React from 'react'

export type ChevronRightIconProps = {
  color?: string
  className?: string
  width?: number
  height?: number
}

export const ChevronRightIcon = ({
  color = 'currentColor',
  className,
  width = 24,
  height = 24,
}: ChevronRightIconProps) => (
  <svg
    aria-label='Chevron right'
    className={className}
    fill='none'
    height={height}
    role='img'
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M9 5L16 12L9 19' stroke={color} strokeWidth='2' />
  </svg>
)
